import { useTranslation } from 'react-i18next';

import { showToast } from 'src/helpers/showToast';
import { useSendInvitations } from 'src/hooks/api';

interface UseSendInvitationOptions {
  onError?: () => void;
  onSuccess?: () => void;
}

export const useSendInvitation = (options: UseSendInvitationOptions = {}) => {
  const { t } = useTranslation(['common', 'invitations']);
  const { isPending, mutate: sendInvitations } = useSendInvitations();

  const sendInvitation = (code: string) => {
    sendInvitations(
      { codes: [code] },
      {
        onError: () => {
          showToast({
            props: {
              description: t('invitations:notification.invitationSendError'),
              title: t('common:notification.somethingWentWrong'),
              type: 'error',
            },
          });

          options.onError?.();
        },
        onSuccess: () => {
          showToast({
            props: {
              title: t('invitations:notification.invitationSent'),
              type: 'success',
            },
          });

          options.onSuccess?.();
        },
      },
    );
  };

  return { isPending, sendInvitation };
};
